export const elsewhereKeys = {
    ELSEWHERE: 'elsewhere',
    USER_IS_AWAY: 'user_is_away',
    USER_IS_BACK: 'user_is_back',
}
